import { memo } from 'react';

import {
  Text,
  Swiper,
  Image,
  useBreakpoint,
  Breakpoint,
  Box,
} from '@betty/moonlight';

import { ProvidersMobile, ProvidersWeb } from './ProvidersSection.constants';
import styles from './ProvidersSection.module.css';

function ProvidersSection() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const itemsMob = ProvidersMobile.map((provider) => ({
    image: '',
    img: provider,
  }));

  const itemsWeb = ProvidersWeb.map((provider) => ({
    image: '',
    img: provider,
  }));

  return (
    <section className={styles.providersSection}>
      <Text variant="h4" gradient="darkSurfaceAccent">
        Our world-class game providers
      </Text>
      <Box
        width="100%"
        flexDirection="column"
        alignItems="center"
        height={{
          desktop: 310,
          tablet: 310,
          mobile: 155,
        }}
      >
        <Swiper
          items={isMobile ? itemsMob : itemsWeb}
          renderOverlayItem={(item) => (
            <div style={{ position: 'relative'}}>
              <Image
                width={150}
                height={isMobile ? 150 : 310}
                name={item.img}
              />
            </div>
          )}
          maxHeight="100%"
          loop={false}
          imageContentFit="contain"
          dragFree={true}
          slidesToScroll={2}
          itemsGap="space-400"
          arrows={isMobile ? false : true}
        />
      </Box>
    </section>
  );
}

export default memo(ProvidersSection);
